import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 版权品征集
 */

var copyrightCollect = {
  path: '/copyrightCollect',
  component: BasicLayout,
  redirect: '/copyrightCollect',
  children: [{
    path: '/copyrightCollect',
    name: 'CopyrightCollect',
    component: function component() {
      return import('views/copyrightCollect/Index');
    },
    meta: {
      title: '征集令',
      keepAlive: true
    }
  }, {
    path: '/copyrightCollect/detail',
    name: 'CopyrightCollectDetail',
    component: function component() {
      return import('views/copyrightCollect/Detail');
    },
    meta: {
      title: '活动详情'
    }
  }, {
    path: '/copyrightCollect/collected',
    name: 'CopyrightCollected',
    component: function component() {
      return import('@/views/copyrightCollect/Products');
    },
    meta: {
      title: '已征集'
    }
  }, {
    path: '/copyrightCollect/select',
    name: 'CopyrightCollectSelect',
    component: function component() {
      return import('@/views/copyrightCollect/Select');
    },
    meta: {
      title: '选择版权品',
      keepAlive: true
    }
  }, {
    path: '/copyrightCollect/confirm',
    name: 'CopyrightCollectConfirm',
    component: function component() {
      return import('@/views/copyrightCollect/Confirm');
    },
    meta: {
      title: '确认版权品'
    }
  }, {
    path: '/copyrightCollect/record',
    name: 'CopyrightCollectRecord',
    component: function component() {
      return import('views/copyrightCollect/Record');
    },
    meta: {
      title: '征集记录'
    }
  }, {
    path: '/copyrightCollect/join',
    name: 'CopyrightCollectJoin',
    component: function component() {
      return import('@/views/copyrightCollect/Products');
    },
    meta: {
      title: '参与版权品'
    }
  }]
};
export default copyrightCollect;